import type { ProjectSummary } from '../../types';

interface ProjectCardProps {
  project: ProjectSummary;
  isSelected: boolean;
  onSelect: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('it-IT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

export function ProjectCard({
  project,
  isSelected,
  onSelect,
  onEdit,
  onDelete
}: ProjectCardProps) {
  return (
    <div
      className={`bg-white rounded-lg shadow p-4 border-2 transition-colors cursor-pointer ${
        isSelected ? 'border-primary-500' : 'border-transparent hover:border-gray-200'
      }`}
      onClick={onSelect}
    >
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900">{project.name}</h3>
          {project.description && (
            <p className="text-sm text-gray-500 mt-1 line-clamp-2">
              {project.description}
            </p>
          )}
        </div>
        {isSelected && (
          <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full">
            Attivo
          </span>
        )}
      </div>

      {/* Stats */}
      <div className="flex gap-4 text-xs text-gray-500 mb-3">
        <span>{project._count.preventivi} preventivi</span>
        <span>{project._count.finanziamenti} finanziamenti</span>
        <span>{project._count.ganttTasks} attività</span>
      </div>

      {/* Footer */}
      <div className="flex justify-between items-center pt-3 border-t">
        <span className="text-xs text-gray-400">
          Creato il {formatDate(project.createdAt)}
        </span>

        <div className="flex gap-2" onClick={(e) => e.stopPropagation()}>
          <button
            onClick={onEdit}
            className="text-xs text-gray-600 hover:text-primary-600 px-2 py-1 rounded hover:bg-gray-50"
          >
            Modifica
          </button>
          <button
            onClick={onDelete}
            className="text-xs text-red-500 hover:text-red-700 px-2 py-1 rounded hover:bg-red-50"
          >
            Elimina
          </button>
        </div>
      </div>
    </div>
  );
}
